import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaderResponse,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from 'app/shared/services/loader.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private count = 0;
  private loaderNotAllowedAddress = new Array<string>();

  constructor(private loaderService: LoaderService) {
    this.loaderNotAllowedAddress.push('push/routeone');
    this.loaderNotAllowedAddress.push('push/dms');
    this.loaderNotAllowedAddress.push('push/dealertrack');

    // these lines are necessary because there is a component that is not part of desking being called inside of desking
    this.loaderNotAllowedAddress.push('Inventory/vehicles/get_vehicles');
    this.loaderNotAllowedAddress.push('Inventory/vehicles/get_locations');
    this.loaderNotAllowedAddress.push('inventory/vehicles/get_security_settings');
    this.loaderNotAllowedAddress.push('Inventory/vehicles/get_agebucket');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ignore = request.headers.get('ignoreInterceptor');
    if (ignore) {
      request = request.clone({
        headers: request.headers.delete('ignoreInterceptor')
      });
      return next.handle(request);
    }

    const currentUser = JSON.parse(localStorage.getItem('currentuser'));


    if (currentUser) {      
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${currentUser.jwt_token}` , 'x-correlation-id': uuid()}
      });
    }

    const blockedUrl = this.loaderNotAllowedAddress.filter(x => request.url.indexOf(x) > 0);
    if (blockedUrl.length === 0) {
      this.count++;
      if (this.count === 1) {
        this.loaderService.setLoading(true);
      }

      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse || event instanceof HttpHeaderResponse) {
              if (this.count > 0) {
                this.count--;
              }
              if (this.count === 0) {
                this.loaderService.setLoading(false);
              }
            }
          },
          (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (this.count > 0) {
                this.count--;
              }
              if (this.count === 0) {
                this.loaderService.setLoading(false);
              }
            }
          }
        )
      );
    } else {
      return next.handle(request);
    }
  }
}